var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Edit Contact Info","size":"sm"},on:{"on-hide":_vm.resetFormData}},[_c('contact-info-form',_vm._b({key:_vm.formKey,on:{"on-submit":_vm.update,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'contact-info-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }